import React, { createContext, useContext, useState } from "react";
const SystemContext = createContext();

export default function SystemProvider({ children }) {
  const [isAlive, setIsAlive] = useState(true);
  return (
    <SystemContext.Provider
      value={{
        isAlive,
        setIsAlive,
      }}
    >
      {children}
    </SystemContext.Provider>
  );
}

export function useSystem() {
  const context = useContext(SystemContext);
  const { isAlive, setIsAlive } = context;
  return {
    isAlive,
    setIsAlive,
  };
}
